var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.lang === 'fr')?_c('img',{staticClass:"flag-icon mr-2",attrs:{"src":require("@/assets/fr.svg")}}):(_vm.lang === 'nl')?_c('img',{staticClass:"flag-icon mr-2",attrs:{"src":require("@/assets/nl.svg")}}):(_vm.lang === 'en')?_c('img',{staticClass:"flag-icon mr-2",attrs:{"src":require("@/assets/en.svg")}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }